import * as React from 'react';

function SvgRightArrow(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={9.516} height={16.198} {...props}>
      <g data-name="Group 17">
        <path
          d="M6.318 8.1l-6.06 6.06a.888.888 0 000 1.253l.531.531a.888.888 0 001.253 0l7.215-7.215a.894.894 0 000-1.257L2.049.264a.888.888 0 00-1.253 0L.265.795a.887.887 0 000 1.253z"
          data-name="Path 138"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export default SvgRightArrow;
